<template>
  <div>
    <div class="rightSideTitle">在途发放记录</div>
    <div style="float:right">
      <el-button type="primary" size="small" @click="updateOnTheWayRecordAuto">自动更新</el-button>
      <el-button type="primary" size="small" @click="updateOnTheWayRecord">使用手动更新数据更新</el-button>
    </div>
    <bsp-table
      height="300px"
      ref="operationMode"
      :data.sync="onTheWayList"
      :ciic-data-filter.sync="operListQuery"
      @ciic-data-refresh="_getOnTheWayRecords"
      @select-change="selectChange"
      @select-all="selectChange"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <vxe-table-column type="selection" width="60" fixed="left" align="center" tree-node></vxe-table-column>
      <bsp-table-column title="付款通知ID" field="payNoticeId" width="130px" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.payNoticeId}}</span>
        </template>
      </bsp-table-column>
      <bsp-table-column title="雇员姓名" field="empName" width="130px" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.empName}}</span>
        </template>
      </bsp-table-column>
      <bsp-table-column title="证件号码" field="identityNum" width="130px" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.identityNum}}</span>
        </template>
      </bsp-table-column>


      <bsp-table-column title="工资所属月份" field="wageMonth" width="130px" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.wageMonth}}</span>
        </template>
      </bsp-table-column>
      <bsp-table-column title="发放金额" field="payAmount" width="130px" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.payAmount}}</span>
        </template>
      </bsp-table-column>
      <bsp-table-column title="批次属性" field="batchProperty" width="130px" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.batchProperty | dictFilter(dicts)}}</span>
        </template>
      </bsp-table-column>

      <bsp-table-column title="计税类型" field="taxType" width="130px" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.taxType | dictFilter(dicts)}}</span>
        </template>
      </bsp-table-column>



      <bsp-table-column title="开户账号" field="accountNum" width="130px" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.accountNum}}</span>
        </template>
      </bsp-table-column>

      <bsp-table-column title="开户名" field="accountName" width="130px" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.accountName}}</span>
        </template>
      </bsp-table-column>

      <bsp-table-column title="银行类别" field="bankType" width="130px" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.bankType | dictFilter(dicts)}}</span>
        </template>
      </bsp-table-column>

      <bsp-table-column title="开户行全称" field="bankFullName" width="130px" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.bankFullName}}</span>
        </template>
      </bsp-table-column>

      <bsp-table-column title="开户地区" field="bankAccountArea" width="130px" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.bankAccountArea}}</span>
        </template>
      </bsp-table-column>

      <bsp-table-column title="工行地区代码" field="ibicAreNum" width="130px" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.ibicAreNum}}</span>
        </template>
      </bsp-table-column>

      <bsp-table-column title="实发" field="actPayAmount" width="130px" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.actPayAmount}}</span>
        </template>
      </bsp-table-column>

      <bsp-table-column title="代报销" field="reimbursementAmount" width="130px" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.reimbursementAmount}}</span>
        </template>
      </bsp-table-column>






    </bsp-table>

  </div>
</template>

<script>
  import BspTable from "@/components/bsp/bsp-table/bsp-table";
  import {getOnTheWayRecords,updateBankInfoHandle,updateBankInfoAuto} from "@/api/biz/refund/refund";
  import BspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
  import {updateOperMode} from "@/api/biz/configCenter/salarySetting";
  import {mapGetters} from 'vuex';

  export default {
    name: "provideRecords",
    props: {
      listForm: {
        type: Object,
        default: () => (
          {}
        )
      },
      cusId: {
        type: Number,
        default: 0
      },
      tenantId: {
        type: Number,
        default: 0
      },
      empId: {
        type: Number,
        default: 0
      },
      refundId: {
        type: Number,
        default: 0
      }
    },
    components: {
      BspTable,
      BspTableColumn,
    },
    computed: {
      ...mapGetters([
        'dicts',
      ]),
    },
    created() {
      this._getOnTheWayRecords();
    },
    data() {
      return {
        loading: false,
        onTheWayList: [],
        salaryDetailIds: [],
        dialogStatus: '',
        dialogFormVisible: false,
        operationModeId: 0,
        multipleSelection: [],
        updateBankInfo: {
          salaryDetailIds: [],
          cusId: '',
          tenantId: '',
          upOpenName: this.listForm.upOpenName,
          upAccountNumber: this.listForm.upAccountNumber,
          upBankType: this.listForm.upBankType,
          upBankFullName: this.listForm.upBankFullName,
          upAccountArea: this.listForm.upAccountArea,
          upIbicAreNum: this.listForm.upIbicAreNum
        },

        operListQuery: {
          limit: 5,
          page: 1,
          total: 0,
          tenantId: this.$route.query.tenantId,
          cusId: this.$route.query.cusId
        },
        deleteRowMark: {
          1: 'cus_operation_mode'
        },
        params: {
          empId: this.empId,
          refundId: this.refundId
        },
        deleteRowParam: {
          tableName: '',
          primarykey: {
            type: Number,
            default: 0
          }
        },

      }
    },
    methods: {
      _getOnTheWayRecords() {
        console.log(this.params);
        getOnTheWayRecords(this.params).then(res => {
          console.log("在途发放记录res=", res);
          this.onTheWayList = res.data.data;
          console.log("this.onTheWayList==", this.onTheWayList)
        })
      },
      selectChange(value) {
        console.log(value);
        if (value.selection) {
          this.multipleSelection = [];
          for (let index = 0; index < value.selection.length; index++) {
            const element = value.selection[index];
            this.multipleSelection.push(element);
          }
        }
      },
      //更新在途发放记录
      updateOnTheWayRecordAuto() {
        if (this.multipleSelection.length > 0) {
          this.$confirm('自动更新将使用雇员银行卡信息进行更新，是否继续？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(()=>{
            this.loading = true;
            for (let i = 0; i < this.multipleSelection.length; i++) {
              this.salaryDetailIds.push(this.multipleSelection[i].salaryDetailId)
            }
            let param = {};
            param.salaryDetailIds = this.salaryDetailIds;
            param.empId = this.empId;
            console.log(param);
            updateBankInfoAuto(param).then(res => {
              let result = res.data;
              if (result.code == 0) {
                this.loading = false;
                this._getOnTheWayRecords();
                this.multipleSelection = [];
                this.$message.success("更新成功");
              } else {
                this.loading = false;
                this.$message.error(result.msg);
              }
            });
          })


        }else{
          this.$message.error("请选择一条记录");
        }
      },
      //更新在途发放记录
      updateOnTheWayRecord() {
        if (this.multipleSelection.length > 0) {
          this.$confirm('手动更新将更新银行信息进行更新，是否继续？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(()=>{
            console.log(this.multipleSelection);
        for (let i = 0; i < this.multipleSelection.length; i++) {
          this.salaryDetailIds.push(this.multipleSelection[i].salaryDetailId)
        }
        this.updateBankInfo.cusId = this.operListQuery.cusId;
        this.updateBankInfo.tenantId = this.operListQuery.tenantId;
        this.updateBankInfo.salaryDetailIds = this.salaryDetailIds;
        this.updateBankInfo.refundId = this.refundId;
        console.log( this.updateBankInfo);
            updateBankInfoHandle(this.updateBankInfo).then(res => {
              if (res.data.code==0) {
                this.multipleSelection = [];
                this.$message.success("更新成功");
                this._getOnTheWayRecords();
              } else {
                this.$message.error(result.msg);
              }
            });
          })
        }else{
          this.$message.error("请选择一条记录");
        }
      }
    }
  }
</script>

<style scoped>

</style>
